(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["edina-schmuckhelfer"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('ej-finder');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';

  const analyticsEndpoint = 'https://edina-jewelry-ki.duckdns.org/webhook/edina-assistent-events-v1';
  const telemetryKey = 'ej_assistant_session_v1';
  let telemetrySession = '';
  let telemetryCount = 0;
  function analyticsAllowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], () => {});
  }
  function track(eventType, detail = '', product = root.dataset.product || '') {
    try {
      if (!analyticsAllowed() || window.Shopify?.designMode || telemetryCount >= 100) return;
      if (!telemetrySession) {
        try { telemetrySession = sessionStorage.getItem(telemetryKey) || ''; } catch (_) {}
        if (!/^[a-z0-9-]{8,80}$/i.test(telemetrySession)) telemetrySession = crypto.randomUUID();
        try { sessionStorage.setItem(telemetryKey, telemetrySession); } catch (_) {}
      }
      const isTest = new URLSearchParams(location.search).get('ej_assistant_test') === '1' || new URLSearchParams(location.search).has('preview_theme_id');
      const payload = {consent:true,event_id:crypto.randomUUID(),event_type:eventType,session_id:telemetrySession,page:location.pathname,detail,product,is_test:isTest,schema_version:1};
      telemetryCount++;
      fetch(analyticsEndpoint,{method:'POST',headers:{'Content-Type':'text/plain;charset=UTF-8'},body:JSON.stringify(payload),credentials:'omit',referrerPolicy:'no-referrer',keepalive:true}).catch(() => {});
    } catch (_) {}
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (!analyticsAllowed()) {
      telemetrySession = '';
      try { sessionStorage.removeItem(telemetryKey); } catch (_) {}
    }
  });
  function questionTopic(text) {
    const s = text.toLowerCase();
    const topics = [
      ['solid_gold',/echtgold|massiv.{0,8}gold|reingold|(?:14|18).?karat/],
      ['order',/bestell|sendungsverfolg|tracking|storn/],
      ['returns',/rückgab|retour|widerruf|zurückschick/],
      ['shipping',/versand|liefer|schweiz|österreich/],
      ['adjustable',/verstell|anpassbar/],
      ['ring_size',/ringgr[oöß]|ringgröße|umfang|durchmesser/],
      ['care',/pflege|dusch|wasser|sport|schlaf|anlauf|abnutz|vergoldung/],
      ['silver',/silber/],
      ['material',/material|nickel|allerg/],
      ['availability',/verfügbar|vorrät|ausverkauft|lager/],
      ['price',/preis|kost|rabatt|gutschein/],
      ['birth_stone',/geburtsstein/],
      ['birth_flower',/geburtsblum|januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember/],
      ['necklace_length',/länge|verlänger/],
      ['gift',/geschenk|geburtstag|hochzeit|weihnacht/],
      ['search',/such|zeig|ring|kette|ohrring|armband|anhänger/]
    ];
    return topics.find(([, pattern]) => pattern.test(s))?.[0] || 'unknown';
  }
  root.addEventListener('click', event => {
    const target = event.target.closest('button,a');
    if (!target || !root.contains(target)) return;
    if (target.dataset.action) track('button_click',target.dataset.action);
    else if (target.classList.contains('ej-finder-back')) track('button_click','back');
    else if (target.classList.contains('ej-finder-close')) track('close');
    else if (target.classList.contains('ej-finder-product')) {
      track('product_click','',new URL(target.href,location.origin).pathname.split('/').filter(Boolean).pop());
    } else if (target.closest('[data-step="categories"]') && target.tagName === 'A') {
      track('category_click',new URL(target.href,location.origin).pathname.split('/').filter(Boolean).pop());
    }
  }, true);

  const panel = root.querySelector('#ej-finder-panel');
  const launch = root.querySelector('.ej-finder-launch');
  const intro = root.querySelector('[data-step="intro"]');
  const categories = root.querySelector('[data-step="categories"]');
  const key = 'ej_finder_seen_v1';
  let seen = false;
  let timer;
  try { seen = sessionStorage.getItem(key) === '1'; } catch (_) {}
  function remember() { seen = true; try { sessionStorage.setItem(key, '1'); } catch (_) {} }
  function open(manual, countOpen = true) {
    if (countOpen) track(manual ? 'open_manual' : 'open_auto');
    clearTimeout(timer);
    remember();
    intro.hidden = false;
    categories.hidden = true;
    panel.hidden = false;
    resizeInput();
    launch.hidden = true;
    launch.setAttribute('aria-expanded', 'true');
    if (manual) root.querySelector('[data-action="browse"]').focus();
  }
  function close() {
    clearTimeout(timer);
    remember();
    const focused = panel.contains(document.activeElement);
    panel.hidden = true;
    launch.hidden = false;
    launch.setAttribute('aria-expanded', 'false');
    if (focused) launch.focus();
  }
  launch.addEventListener('click', () => open(true));
  root.querySelector('.ej-finder-close').addEventListener('click', close);
  root.querySelector('[data-action="browse"]').addEventListener('click', close);
  root.querySelector('[data-action="specific"]').addEventListener('click', () => {
    intro.hidden = true;
    categories.hidden = false;
    categories.querySelector('h2').focus();
  });
  root.querySelector('.ej-finder-back').addEventListener('click', () => open(true, false));
  root.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
  root.addEventListener('keydown', event => { if (event.key === 'Escape' && !panel.hidden) { close(); event.preventDefault(); } });
  const form = root.querySelector('.ej-finder-form');
  const field = root.querySelector('textarea');
  function resizeInput() {
    if (!field.getClientRects().length) return;
    field.style.height = 'auto';
    const height = Math.max(46, field.scrollHeight + 2);
    field.style.height = Math.min(height, 166) + 'px';
    field.style.overflowY = height > 166 ? 'auto' : 'hidden';
  }
  field.addEventListener('input', resizeInput);
  window.addEventListener('resize', resizeInput);
  const submit = form.querySelector('button');
  const conversation = root.querySelector('.ej-finder-conversation');
  const answer = root.querySelector('.ej-finder-answer');
  const cards = root.querySelector('.ej-finder-products');
  const history = [];
  const base = window.Shopify?.routes?.root || '/';
  const message = name => root.querySelector('[data-' + name + ']').textContent;
  let pending = false;
  async function productCard(handle) {
    if (!/^[a-z0-9-]+$/.test(handle)) return null;
    const response = await fetch(base + 'products/' + handle + '.js', { signal: AbortSignal.timeout(8000) });
    if (!response.ok) return null;
    const product = await response.json();
    const link = document.createElement('a');
    link.className = 'ej-finder-product';
    link.href = base + 'products/' + handle;
    if (product.featured_image) {
      const url = new URL(product.featured_image, location.origin);
      if (url.protocol === 'https:') {
        url.searchParams.set('width', '160');
        const img = document.createElement('img');
        img.src = url.href; img.alt = product.title; img.width = 62; img.height = 76; img.loading = 'lazy';
        link.append(img);
      }
    }
    const info = document.createElement('span');
    const title = document.createElement('strong'); title.textContent = product.title;
    const price = document.createElement('small');
    price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(product.price / 100);
    info.append(title, price);
    if (!product.available) { const unavailable = document.createElement('small'); unavailable.textContent = message('unavailable'); info.append(unavailable); }
    link.append(info);
    return link;
  }
  form.addEventListener('submit', async event => {
    event.preventDefault();
    const text = field.value.trim();
    if (!text || pending) return;
    track('question_submit', questionTopic(text));
    pending = true; submit.disabled = true;
    conversation.hidden = false; cards.replaceChildren();
    answer.textContent = message('loading');
    try {
      const response = await fetch(root.dataset.endpoint, {
        method:'POST', headers:{'Content-Type':'text/plain;charset=UTF-8'},
        body:JSON.stringify({message:text, product:root.dataset.product || '', history:history.slice(-4)}),
        signal:AbortSignal.timeout(30000), credentials:'omit'
      });
      if (!response.ok) throw new Error('unavailable');
      const data = await response.json();
      if (typeof data.answer !== 'string') throw new Error('invalid response');
      track('answer_received', ['search','solid_gold','adjustable','care','shipping','returns','other','unknown','unavailable'].includes(data.topic) ? data.topic : 'unknown');
      answer.textContent = data.answer;
      const results = await Promise.allSettled((Array.isArray(data.handles)?data.handles:[]).slice(0,3).map(productCard));
      for (const result of results) if (result.status === 'fulfilled' && result.value) cards.append(result.value);
      if (data.topic !== 'unavailable') {
        history.push({role:'user',content:text},{role:'assistant',content:data.answer});
        if (history.length>4) history.splice(0,history.length-4);
        field.value = '';
        resizeInput();
      }
    } catch (_) { track('answer_error','network_error'); answer.textContent = message('error'); }
    finally { pending = false; submit.disabled = false; }
  });
  root.hidden = false;
  function autoOpen() {
    if (seen || document.hidden) return;
    const blockers = document.querySelectorAll('dialog[open], [aria-modal="true"], cart-drawer[open], newsletter-popup[open], #shopify-pc__banner');
    if ([...blockers].some(el => el.getClientRects().length > 0)) {
      timer = setTimeout(autoOpen, 10000);
      return;
    }
    open(false);
  }
  if (!seen && !(window.Shopify && window.Shopify.designMode)) timer = setTimeout(autoOpen, 30000);
})();
  } catch(e) { console.error(e); }
})();

})();
